import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import InstitutionsListView from "./institutions-list.html";
import InstitutionsEditView from "./institutions-edit.html";


angular.module('institutions', [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('institutions', {
                url: "/institutions",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('institutions.list', {
                url: "/list",
                controller: "institutionsListCtrl",
                template: InstitutionsListView,
                requiredPermission: ["PERSONS_WRITE"]
            })

            .state('institutions.edit', {
                url: "/edit/:id",
                controller: "institutionsEditCtrl",
                template: InstitutionsEditView,
                data: { pageTitle: "Servicio" },
                resolve: {
                    id_from_modal: function () {
                        return false;
                    },
                },
                requiredPermission: ["PERSONS_WRITE"]
            })

    }])
    ;